import { DS_SHAPE_SPACING } from '@calm/evexia-design-tokens';
import { Box, Container, SxProps, Theme } from '@rhg/libs/material';
import { NumberByBreakpoint, sxAppend } from '@rhg/libs/material/sx';
import { PropsWithChildren } from 'react';

export const fullPagePadding: NumberByBreakpoint = {
    xl: 8,
    lg: 8,
    md: 4,
    sm: 4,
    xs: 4,
};

export const fullPagePaddingPx = Object.fromEntries(
    Object.entries(fullPagePadding).map(([key, value]) => [
        key,
        value * DS_SHAPE_SPACING.BASE,
    ])
) as NumberByBreakpoint;

const styleFullPagePaddedContainer = {
    px: fullPagePadding,
};

export function FullPagePaddedContainer({
    children,
    sx,
}: PropsWithChildren<{ sx?: SxProps<Theme> }>) {
    return (
        <Container
            sx={sxAppend(styleFullPagePaddedContainer, sx)}
            maxWidth={false}
        >
            {children}
        </Container>
    );
}

export function FullPageFullWidthContainer({
    children,
    sx,
}: PropsWithChildren<{ sx?: SxProps<Theme> }>) {
    return <Box sx={sx}>{children}</Box>;
}
